import React, { useState, useEffect } from 'react';
import MainMenu from './components/MainMenu';
import Game from './components/Game';
import Logo from './components/Logo';

function App() {
  const [gameStatus, setGameStatus] = useState('logo');
  const [musicSettings, setMusicSettings] = useState(() => {
    const musicVolume = parseFloat(localStorage.getItem('musicVolume')) || 0.5;
    const sfxVolume = parseFloat(localStorage.getItem('sfxVolume')) || 0.5;
    const isMusicEnabled = localStorage.getItem('isMusicEnabled') === 'true'; // Changed to strict 'true'
    const isSfxEnabled = localStorage.getItem('isSfxEnabled') === 'true'; // Changed to strict 'true'
    const isFpsCounterEnabled = localStorage.getItem('isFpsCounterEnabled') === 'true'; // Default to false unless explicitly 'true'
    return {
      musicVolume,
      sfxVolume,
      isMusicEnabled,
      isSfxEnabled,
      isFpsCounterEnabled,
    };
  });
  const [level, setLevel] = useState(1);

  useEffect(() => {
    if (gameStatus === 'logo') {
      const timer = setTimeout(() => {
        setGameStatus('menu');
      }, 3500);
      return () => clearTimeout(timer);
    }
  }, [gameStatus]);

  useEffect(() => {
    console.log('App musicSettings:', musicSettings);
  }, [musicSettings]);

  const startGame = (settings, selectedLevel) => {
    setMusicSettings(settings || {
      musicVolume: 0.5,
      sfxVolume: 0.5,
      isMusicEnabled: true,
      isSfxEnabled: true,
      isFpsCounterEnabled: false, // Ensure default is false
    });
    setLevel(selectedLevel || 1);
    setGameStatus('playing');
  };

  const returnToMenu = (nextLevel) => {
    if (nextLevel && Number.isInteger(nextLevel) && nextLevel >= 1) {
      startGame(musicSettings, nextLevel);
    } else {
      setGameStatus('menu');
    }
  };

  return (
    <div className="h-screen w-screen overflow-hidden">
      {gameStatus === 'logo' && <Logo />}
      {gameStatus === 'menu' && (
        <MainMenu
          onPlay={startGame}
          musicSettings={musicSettings}
          setMusicSettings={setMusicSettings}
        />
      )}
      {gameStatus === 'playing' && (
        <Game
          onGameOver={returnToMenu}
          musicSettings={musicSettings}
          level={level}
        />
      )}
    </div>
  );
}

export default App;